
import React from "react";

export const AdminDashboardHeader: React.FC = () => {
  return (
    <div className="mb-10">
      <h1 className="text-4xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-[#00B6F0] to-[#5fceff] pb-2">
        Painel do Administrador
      </h1>
      <p className="text-gray-400 text-lg">Gerencie jogos, usuários e mentorias</p>
    </div>
  );
};
